// Spanish (`es`) shell baseline
import { layoutEs } from './es/layout'
import { homeEs } from './es/home'
import { playEs } from './es/play'
import { demoEs } from './es/demo'
import { booksEs } from './es/books'
import { commerceEs } from './es/commerce'
import { communityEs } from './es/community'
import { dashboardEs } from './es/dashboard'
import { authEs } from './es/auth'
import { marketingEs } from './es/marketing'
import { worldEs } from './es/world'
import { encyclopediaEs } from './es/encyclopedia'
import { systemEs } from './es/system'
import { cityEs } from './es/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseEs: MessageCatalog = {
  ...layoutEs,
  ...homeEs,
  ...playEs,
  ...demoEs,
  ...booksEs,
  ...commerceEs,
  ...communityEs,
  ...dashboardEs,
  ...authEs,
  ...marketingEs,
  ...worldEs,
  ...encyclopediaEs,
  ...systemEs,
  ...cityEs,
}
